/**
 * @file index.tsx
 *
 * @fileoverview Renders a single radio input.
 */

import React from "react";
import styles from "./radio.module.scss";

export interface RadioProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Label shown next to the radio input.
   */
  title: string;
  /**
   * Unique id for the input and label binding.
   */
  id: string;
  /**
   * Group name for radio inputs.
   */
  name: string;
  /**
   * Value submitted when this radio is selected.
   */
  value: string;
  /**
   * Marks this radio as selected by default.
   */
  isSelected?: boolean;
}

export const Radio = ({
  title,
  id,
  name,
  value,
  isSelected = false,
  ...props
}: RadioProps) => {
  return (
    <div>
      <input
        className={styles.radio}
        id={id}
        type="radio"
        name={name}
        value={value}
        defaultChecked={isSelected}
        {...props}
      />
      <label className={styles.label} htmlFor={id}>
        {title}
      </label>
    </div>
  );
};

export default Radio;

